import React from 'react'
import { FooterContainer } from './FooterElements'

const Footer = () => {
  return (
    <FooterContainer>© 2023 Fiona Li | All Rights Reserved</FooterContainer>
  )
}

export default Footer